import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeatureSection from './components/FeatureSection';
import HowItWorks from './components/HowItWorks';
import ArticleEntry from './components/ArticleEntry';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://superbuyspread.study';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Superbuy Spreadsheet',
  url: siteUrl,
  description: 'The most complete Superbuy Spreadsheet knowledge platform. Guides, templates, tutorials, product tracking methods, price comparison strategies and advanced tips to improve your shopping workflow.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Superbuy Spreadsheet',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeatureSection />
        <HowItWorks />
        <ArticleEntry />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}